import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import {
  ForgotPasswordRequestPayload,
  ForgotPasswordResetLinkRequestPayload,
  LoginCredentialsPayload,
  LogoutCredentialsPayload,
  NewPasswordCredentialsPayload,
} from '../../types'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryConfigured,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (payload: LoginCredentialsPayload) => ({
        url: CONSTANTS.API.LOGIN,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
    updatePasswordFromChallenge: builder.mutation({
      query: (payload: NewPasswordCredentialsPayload) => ({
        url: CONSTANTS.API.PASSWORD_CHALLENGE,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
    logout: builder.mutation({
      query: (payload: LogoutCredentialsPayload) => ({
        url: CONSTANTS.API.LOGOUT,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
    requestForgotPasswordLink: builder.mutation({
      query: (payload: ForgotPasswordResetLinkRequestPayload) => ({
        url: CONSTANTS.API.FORGOT_PASSWORD,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
    resetForgottenPassword: builder.mutation({
      query: (payload: ForgotPasswordRequestPayload) => ({
        url: CONSTANTS.API.UPDATE_PASSWRD,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
    getGroupsForUser: builder.mutation({
      query: () => ({
        url: CONSTANTS.API.MY_GROUPS,
        method: 'GET',
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useLogoutMutation,
  useUpdatePasswordFromChallengeMutation,
  useRequestForgotPasswordLinkMutation,
  useResetForgottenPasswordMutation,
  useGetGroupsForUserMutation
} = authApi
